import { useState } from "react";
import FileSelectView from "components/file-system/FileSelectView";
import { FileSystemItem } from "types";
import { useTranslation } from "react-i18next";
import { Library } from "constants/library";

export const LibraryDialogContent = ({
  selectedItems,
  handleConfirm,
  setIsLibraryOpen,
  filterItem,
  rootFolderName = Library.DOCUMENTS,
  selectionMode = "file",
}: {
  selectedItems: FileSystemItem[];
  handleConfirm: (items: FileSystemItem[]) => void;
  setIsLibraryOpen: (l: boolean) => void;
  filterItem?: (items: FileSystemItem[]) => FileSystemItem[];
  rootFolderName?: string;
  selectionMode?: "file" | "folder";
}) => {
  const { t } = useTranslation();
  const [selectedFiles, setSelectedFiles] = useState(selectedItems);
  return (
    <div className="relative mx-auto w-[70vw] rounded-xl ">
      <div className="mt-4">
        <FileSelectView
          selectedFiles={selectedFiles}
          filterFile={filterItem}
          setSelectedFiles={setSelectedFiles}
          rootFolderName={rootFolderName}
          selectionMode={selectionMode}
        />
      </div>

      <div className="bottom-0 mt-6 flex justify-end gap-2 ">
        <button
          type="button"
          onClick={() => {
            setIsLibraryOpen(false);
          }}
          className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-navy-600 dark:hover:text-white"
        >
          {t("common.cancel")}
        </button>
        <button
          type="button"
          onClick={() => {
            handleConfirm(selectedFiles);
            setIsLibraryOpen(false);
          }}
          className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 dark:bg-brand-400 dark:text-navy-800 dark:hover:bg-brand-300"
        >
          {t("common.confirm")}
        </button>
      </div>
    </div>
  );
};
